/**
 * EMailContent.js
 * 
 * Created on Oct 28, 2013, 09:31:01
 *
 * @author Olivier van der Pool for Ranj
 **/

import { isUndefined } from "../../util/TypeUtil";
import EMailBaseContent from "./EMailBaseContent";

export default class EMailContent extends EMailBaseContent {
    constructor(languagePack, contentID, id, sender, recipients, ccs, subject, content, dateTimeOffset, priority, attachments, replyDraftID, label) {
        isUndefined(content) ? content = null : null;
        isUndefined(replyDraftID) ? replyDraftID = null : null;

        super(languagePack, contentID, EMailContent.NAME, EMailContent.TYPE, id, sender, recipients, ccs, subject, dateTimeOffset, priority, attachments, label);

        this._content = content;
        this._replyDraftID = replyDraftID;
    }

    setContent(value) {
        if (this._content !== value) {
            this.setLanguagePackText(EMailContent.CONTENT_LABEL, value);
        }
    }

    getContent() {
        return this.getLanguagePackText(EMailContent.CONTENT_LABEL);
    }

    exportText(csv) {
        console.warn("[EMailContent]", "the method exportText is not yet implemented!");
        //this.exportText(csv);
        //csv.addRecordSet([this.getLanguagePackLabel(SENDER_LABEL), this.getLanugagePackText(SENDER_LABEL), "sms sender"]);
        //csv.addRecordSet([this.getLanguagePackLabel(TEXT_LABEL), this.getLanugagePackText(TEXT_LABEL), "sms text"]);
    }

    convertToObject() {
        return this.getObject(["replyDraftID"]);
    }
}

EMailContent.NAME = "Email";
EMailContent.TYPE = "engEMailContent";
EMailContent.CONTENT_LABEL = "content";
